import React, { useState, useRef } from 'react';  
import { IoMdPhotos } from "react-icons/io";  
import axios from 'axios';  
import { useToken } from '../contex/TokenProvider';
import '../Style/HomeSlider.css';  
import {Link} from "react-router-dom";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import BaseUrl from '../api/BaseUrl';

function HomeSlider() {  

  const {token} = useToken();

  // State to hold the image URLs and files  
  const [imageDesktop, setImageDesktop] = useState(null);  
  const [imageMobile, setImageMobile] = useState(null);  
  const desktopFileInputRef = useRef(null);  
  const mobileFileInputRef = useRef(null);  
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Handle file selection for desktop  
  const handleDesktopFileChange = (event) => {  
    const file = event.target.files[0];
    if (file) {  
      const imageUrl = URL.createObjectURL(file);  
      setImageDesktop(imageUrl);  
    }  
  };  

  // Handle file selection for mobile  
  const handleMobileFileChange = (event) => {  
    const file = event.target.files[0];  
    if (file) {  
      const imageUrl = URL.createObjectURL(file);  
      setImageMobile(imageUrl);  
    }  
  };  

  // Trigger file input click for desktop  
  const triggerDesktopFileInput = () => {  
    desktopFileInputRef.current.click();  
  };  

  // Trigger file input click for mobile  
  const triggerMobileFileInput = () => {  
    mobileFileInputRef.current.click();  
  };  

  // Function to upload images to the server  
  // Function to upload images to the server  
const handleUpload = async () => {  
  const formData = new FormData();  
  const desktopInput = desktopFileInputRef.current;  
  const mobileInput = mobileFileInputRef.current;  

  // Append desktop image if available  
  if (desktopInput.files.length > 0) {  
    const desktopFile = desktopInput.files[0];   
    formData.append('imageDesktop', desktopFile);  
  } else {  
    console.log("No desktop image selected.");  
  }  

  // Append mobile image if available  
  if (mobileInput.files.length > 0) {  
    const mobileFile = mobileInput.files[0];   
    formData.append('imageMobile', mobileFile);  
  } else {  
    console.log("No mobile image selected.");  
  }  

  // Log FormData entries  
  for (let pair of formData.entries()) {  
    console.log(`${pair[0]}: ${pair[1].name}`);  
  }
  
  setLoading(true);

  try {  
    //console.log("JWT TOKEN:", token);
    const response = await BaseUrl.post('/HomeSlider/add-homeslider-image', formData, {  
      headers: {  
        'Authorization': `Bearer ${token}`,  
      },  
    });  

   
    setMessage(response.data.message); 
    setImageDesktop(null);
    setImageMobile(null);
  } catch (error) { 
    let message = "";
    if(error.response){
      if(error.response.status == 401){
        message = "An unexpected error occurred. Please try again.";
      }
      setErrorMessage(error.response.data.message || message);
    }
  }finally{
    setLoading(false);
  }  
};

  const isUploadDisabled = !imageDesktop || !imageMobile;

  return (  
    <div>  
      <div className='bg-slate-100 w-[700px] min-h-[400px] py-5 shadow-lg hover:shadow-xl flex flex-col gap-10 justify-center items-center'>  
        <h1 className='text-[20px] font-bold text-gray-600'>HERO SECTION</h1>
        {errorMessage && <p className='text-red-500 text-center'>{errorMessage}</p>}
        {message && <p>{message}</p>}
        <div className='flex flex-row gap-2 justify-center items-center'>  
          <div className='flex flex-col justify-center items-center w-[180px] px-2 py-1 gap-2'>  
            <div className='slider'>  
              <button onClick={triggerDesktopFileInput}>  
                {imageDesktop ? (  
                  <img src={imageDesktop} alt="Desktop upload" className="w-full h-full object-cover" />  
                ) : (  
                  <IoMdPhotos />  
                )}  
              </button>  
              <input  
                type='file'  
                accept='.jpeg, .jpg, .png'  
                onChange={handleDesktopFileChange}  
                ref={desktopFileInputRef}  
                style={{ display: 'none' }} // Hide the file input  
              />  
            </div>  
            <button className='px-2 py-1 bg-green-500 rounded-lg text-white text-[12px] font-bold' onClick={triggerDesktopFileInput}>  
              Select  
            </button>  
            <p>For Desktop View</p>  
          </div>  

          <div className='flex flex-col justify-center items-center w-[180px] px-2 py-1 gap-2'>  
            <div className='slider'>  
              <button onClick={triggerMobileFileInput}>  
                {imageMobile ? (  
                  <img src={imageMobile} alt="Mobile upload" className="w-full h-full object-cover" />  
                ) : (  
                  <IoMdPhotos />  
                )}  
              </button>  
              <input  
                type='file'  
                accept='.jpeg, .jpg, .png'  
                onChange={handleMobileFileChange}  
                ref={mobileFileInputRef}  
                style={{ display: 'none' }} // Hide the file input  
              />  
            </div>  
            <button className='px-2 py-1 bg-green-500 rounded-lg text-white text-[12px] font-bold' onClick={triggerMobileFileInput}>  
              Select  
            </button>  
            <p>For Mobile View</p>  
          </div>  
        </div>  

        <div className='flex flex-row gap-5'>  
          <button className={`px-6 py-4 bg-green-500 rounded-lg text-white text-[12px] font-bold ${isUploadDisabled ? 'bg-slate-300' : 'bg-green-500'}`} 
            onClick={handleUpload}
            disabled={isUploadDisabled}
            >
              {loading ? <AiOutlineLoading3Quarters className="loading h-2 w-6 text-[35px]" /> : "Upload"}
            </button>  
          <Link className='px-6 py-4 bg-green-500 rounded-lg text-white text-[12px] font-bold' to={'/homesliderview'}>View</Link>
           
        </div>  
      </div>  
    </div>  
  );  
}  

export default HomeSlider;